// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"8fcfcffe","415":"d8ad9137","805":"b5908817"}[chunkId] + ".chunk.js";
};